module.exports = __webpack_public_path__ + "static/media/loader.8c636777.gif";